import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, DestroyRef, inject, input, OnInit, output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { ButtonModule, IconModule } from '@hglobal/common';
import { TranslateModule } from '@ngx-translate/core';
import { tap, timer } from 'rxjs';

import { Notification } from '../notifications.entities';
import { ThreeDsContentComponent } from '../three-ds-content/three-ds-content.component';

@Component({
  selector: 'pp-three-ds-toast',
  imports: [CommonModule, TranslateModule, ThreeDsContentComponent, ButtonModule, IconModule],
  templateUrl: './three-ds-toast.component.html',
  styleUrl: './three-ds-toast.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThreeDsToastComponent implements OnInit {
  readonly #destroyRef = inject(DestroyRef);

  readonly message = input<Notification>();
  readonly closeToast = output<{
    isManual: boolean;
  }>();
  readonly markAsRead = output<void>();

  readonly notificationLiveTime = 180 * 1000; // 3 min

  ngOnInit() {
    this.#setTimer();
  }

  close(isManual?: boolean): void {
    this.closeToast.emit({ isManual });
  }

  #setTimer(): void {
    timer(this.notificationLiveTime)
      .pipe(
        takeUntilDestroyed(this.#destroyRef),
        tap(() => this.close()),
      )
      .subscribe();
  }
}
